export default "__VITE_ASSET__usnImhsK__"